import {
  Text,
  Button,
  IconComponent,
  IconBarsThree,
  IconLayoutGrid,
  GreyGrey10,
  GreyGrey40,
  GreyGrey60,
  GreyWhite,
  Link,
  Primary12SemiBold,
  ShadowS,
  BorderRadius8,
  Center,
  Flex
} from '@sequencehq/core-components'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'
import { useDefaultCurrency } from 'SettingsV2/index'
import { INVOICES_DEFAULT_SORT_BY } from 'components/Invoices/invoices.constants'

const ViewToggleButton = ({
  icon: Icon,
  label,
  isActive,
  to,
  'data-testid': dataTestId
}: {
  icon: IconComponent
  label: string
  isActive: boolean
  to: string
  'data-testid'?: string
}) => {
  const styleActive = {
    boxShadow: ShadowS,
    border: 'rgba(55, 66, 250, 1) 1px solid',
    background: GreyWhite,
    color: 'rgba(55, 66, 250, 1)'
  }

  const styleInactive = {
    border: `${GreyGrey40} 1px solid`,
    background: GreyGrey10,
    color: GreyGrey60
  }

  return (
    <Button
      as={Link.Unstyled}
      to={to}
      data-testid={dataTestId}
      variant="unstyled"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        flexShrink: '0',
        padding: '8px',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'initial',
        minWidth: 'initial',
        gap: '2px',
        borderRadius: BorderRadius8,
        ...(isActive ? styleActive : styleInactive)
      }}
      hover={styleActive}
    >
      <Center flexShrink="0">
        <Icon color="inherit" />
      </Center>
      <Text {...Primary12SemiBold} color="inherit">
        {label}
      </Text>
    </Button>
  )
}

export const InvoicesViewSettingsHeader = () => {
  const defaultCurrency = useDefaultCurrency()
  const [searchParams] = useSearchParams()

  const isGridViewActive = useMemo(() => {
    const view = searchParams.get('view')
    return view === 'grid'
  }, [searchParams])

  return (
    <Flex p="4px" gap="8px" data-testid="invoices.viewToggle">
      <ViewToggleButton
        icon={IconBarsThree}
        label="List"
        to={`/invoices?sortBy=${INVOICES_DEFAULT_SORT_BY}`}
        isActive={!isGridViewActive}
        data-testid="invoices.viewToggle.list"
      />
      <ViewToggleButton
        icon={IconLayoutGrid}
        label="Grid"
        to={`/invoices?view=grid&currency=${defaultCurrency}`}
        isActive={isGridViewActive}
        data-testid="invoices.viewToggle.grid"
      />
    </Flex>
  )
}
